"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _reactRedux = require("react-redux");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ramda = require("ramda");
var _selectors = require("@otpusk/apisearch-toolbox/dist/services/selectors");
var _fn = require("@otpusk/apisearch-toolbox/dist/queries/fn");
var _selectors2 = require("@otpusk/apisearch-toolbox/dist/queries/selectors");
var _dictionary = require("@otpusk/json-api/dist/dictionary");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _actions = require("../../../../../../bus/ui/actions");
var _Alert = _interopRequireWildcard(require("../../../../../ui/Alert"));
var _Button = _interopRequireWildcard(require("../../../../../ui/Button"));
var _CircleLoader = _interopRequireDefault(require("../../../../../ui/CircleLoader"));
var _RenderWhen = _interopRequireDefault(require("../../../../../RenderWhen"));
var _actions2 = require("./store/actions");
var _constants = require("./store/constants");
var _selectors3 = require("./store/selectors");
var _ButtonTrigger = require("./components/ButtonTrigger");
var _List = require("./components/List");
var _styles = _interopRequireDefault(require("./styles"));
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var StyledRootDiv = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  :hover {\n    border-color: ", "\n  }\n"])), function (props) {
  return props.theme.primaryColor;
});
var BookingServices = function BookingServices(_ref) {
  var offerID = _ref.offerID,
    queryID = _ref.queryID;
  var dispatch = (0, _reactRedux.useDispatch)();
  var _useTranslation = (0, _reactI18next.useTranslation)('OFFER_DETAILS'),
    t = _useTranslation.t;
  var isShow = (0, _reactRedux.useSelector)(_selectors3.getIsShow);
  var fetchBookingServicesUI = (0, _reactRedux.useSelector)(_selectors3.getFetchBookingServicesUI);
  var recalculateOfferPriceUI = (0, _reactRedux.useSelector)(_selectors3.getRecalculateOfferPriceUI);
  var currencyCode = (0, _reactRedux.useSelector)(function (state) {
    return (0, _selectors2.getQueryParam)(state, {
      paramName: _fn.QUERY_PARAMS.CURRENCY,
      queryID: queryID
    });
  });
  var adults = (0, _reactRedux.useSelector)(function (state) {
    return (0, _selectors2.getQueryParam)(state, {
      paramName: _fn.QUERY_PARAMS.ADULTS,
      queryID: queryID
    });
  });
  var children = (0, _reactRedux.useSelector)(function (state) {
    return (0, _selectors2.getQueryParam)(state, {
      paramName: _fn.QUERY_PARAMS.CHILDREN,
      queryID: queryID
    }).size;
  });
  var bookingServices = (0, _reactRedux.useSelector)(function (state) {
    return (0, _selectors.getBookingServicesByOffer)(state, {
      currency: currencyCode,
      offerID: offerID
    });
  });
  var shouldRecalculatePrice = (0, _reactRedux.useSelector)(_selectors3.getShouldRecalculatePrice);
  var isEmptyListOfServices = fetchBookingServicesUI.completed && (0, _ramda.isEmpty)(bookingServices);
  var currency = (0, _react.useMemo)(function () {
    return (0, _dictionary.getCurrencyByCode)(currencyCode);
  }, [currencyCode]);
  var onClickAtToggleButton = function onClickAtToggleButton() {
    if (isEmptyListOfServices) {
      dispatch((0, _actions2.setIsShow)(!isShow));
    } else {
      dispatch(isShow ? (0, _actions2.hideBookingServices)(offerID, queryID) : (0, _actions2.showBookingServices)(offerID, queryID));
    }
  };
  (0, _react.useEffect)(function () {
    return function () {
      dispatch((0, _actions.unRegister)(_constants.FETCH_BOOKING_SERVICES_DATA));
      dispatch((0, _actions.unRegister)(_constants.RECALCULCATE_OFFER_PRICE));
    };
  }, [dispatch]);
  if (fetchBookingServicesUI.error) {
    return /*#__PURE__*/_react.default.createElement(_Alert.default, {
      className: _styles.default.alert
    }, t('BOOKING_SERVICES_NOT_CONNECTED'));
  }
  return /*#__PURE__*/_react.default.createElement(StyledRootDiv, {
    className: _styles.default.root
  }, /*#__PURE__*/_react.default.createElement(_ButtonTrigger.ButtonTrigger, {
    countOfAdults: adults,
    countOfChildren: children,
    isCollapsed: isShow,
    onClick: !fetchBookingServicesUI.loading ? onClickAtToggleButton : undefined
  }), /*#__PURE__*/_react.default.createElement(_RenderWhen.default, null, /*#__PURE__*/_react.default.createElement(_RenderWhen.default.If, {
    isTrue: fetchBookingServicesUI.loading
  }, /*#__PURE__*/_react.default.createElement(_CircleLoader.default, {
    className: _styles.default.loader
  })), /*#__PURE__*/_react.default.createElement(_RenderWhen.default.If, {
    isTrue: isShow && isEmptyListOfServices
  }, /*#__PURE__*/_react.default.createElement(_Alert.default, {
    className: _styles.default.noServices
  }, t('NO_ADDITIONAL_SERVICES'))), /*#__PURE__*/_react.default.createElement(_RenderWhen.default.If, {
    isTrue: isShow && !(0, _ramda.isEmpty)(bookingServices)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.dropdown
  }, /*#__PURE__*/_react.default.createElement(_List.BookingServicesList, null, (0, _ramda.map)(function (bookingService) {
    return /*#__PURE__*/_react.default.createElement(_List.BookingServicesList.Item, {
      currency: currency,
      id: bookingService.id,
      name: bookingService.name,
      key: bookingService.id,
      price: bookingService.price[currencyCode],
      type: bookingService.type,
      enabledTourists: bookingService.enabledTourists,
      countOfPeople: adults + children,
      isGlobalService: bookingService.isGlobalService,
      disabled: bookingService.disabled,
      excludedServices: bookingService.excludedServices
    });
  }, bookingServices)), /*#__PURE__*/_react.default.createElement(_RenderWhen.default, null, /*#__PURE__*/_react.default.createElement(_RenderWhen.default.If, {
    isTrue: !recalculateOfferPriceUI.error
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: _styles.default.submit,
    disabled: !shouldRecalculatePrice,
    loading: recalculateOfferPriceUI.loading,
    theme: _Button.THEMES.PURPLE,
    onClick: !recalculateOfferPriceUI.loading || !shouldRecalculatePrice ? function () {
      return dispatch((0, _actions2.recalculateOfferPrice)(offerID, queryID));
    } : undefined
  }, t('BOOKING_SERVICES_RECALCULATE_BUTTON'))), /*#__PURE__*/_react.default.createElement(_RenderWhen.default.If, {
    isTrue: recalculateOfferPriceUI.error
  }, /*#__PURE__*/_react.default.createElement(_Alert.default, {
    className: _styles.default.alert,
    type: _Alert.TYPES.ERROR
  }, t('RECALCULATE_OFFER_PRICE_ERROR'))))))));
};
BookingServices.propTypes = {
  offerID: _propTypes.default.string.isRequired,
  queryID: _propTypes.default.string.isRequired
};
var _default = exports.default = (0, _react.memo)(BookingServices);